import React, { useEffect, useState } from 'react';
import CardScreen from '../../shared/components/CardScreen';
import logoeden from '../../../images/logo-edenred.png';
import '../../shared/styles/cards.scss';

const PasswordReseted: (props: { message: string, loading: boolean }) => JSX.Element = ({ message, loading }) => {
    const [timeLeft, setTimeLeft] = useState<number>(10);
    useEffect(() => {
        const intervalId = setInterval(() => {
            setTimeLeft((t) => t > 0 ? t - 1 : 0);
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        if (timeLeft <= 0) window.location.href =`${window.location.origin}${process.env.PUBLIC_URL}`;      
    }, [timeLeft]);

    return (
        <CardScreen loading={loading} className='eden-main-screen-card'>
            <img alt="EdenRed" src={logoeden} width={'20%'} style={{ marginBottom: '1rem' }} />
            <p style={{ fontSize: '2rem', textAlign: 'center' }}>{`${message}, en ${timeLeft} segundos seras redireccionado`}</p>
        </CardScreen>
    );
}

export default PasswordReseted;